<app-search-ui></app-search-ui>

<nb-card>
  <nb-card-body>
    <h3>eGlu Map <span><mat-spinner *ngIf="isLoading" [diameter]="24"></mat-spinner></span>
    </h3>
    <p *ngIf="geoPositions.length">Displaying {{geoPositions.length}}/{{totalHubs}} hubs</p>
    <google-map [center]="position" [zoom]="4" width="100%" height="36.5625rem">

      <map-marker #markerElem *ngFor="let marker of geoPositions" (mapClick)="openInfo(markerElem, marker)"
        [position]="marker.position" [clickable]="true" [options]="marker.options">
      </map-marker>
      <map-info-window *ngIf="markerContent">
        {{markerContent.hubData.fullName}}
        <!-- {{markerContent.hubData.isOnline}} -->
        <span *ngIf="markerContent.hubData.isOnline">
          <img src="../../../images/green_new_dot.png" alt="" srcset="">
        </span>
        <span *ngIf="!markerContent.hubData.isOnline">
          <img src="../../../images/red_new_dot.png" alt="" srcset="">
        </span>
        <br>
        {{markerContent.hubData.emailId}} <br>
        <span *ngIf="markerContent.hubData.mobile">
          {{markerContent.hubData.mobile}} <br>
        </span>
        {{markerContent.hubData.firmwareVersion}}
      </map-info-window>
    </google-map>
  </nb-card-body>
</nb-card>
